import { render, staticRenderFns } from "./ResettaPassword.vue?vue&type=template&id=ab647772&scoped=true&"
import script from "./ResettaPassword.vue?vue&type=script&lang=js&"
export * from "./ResettaPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab647772",
  null
  
)

export default component.exports